export const DEFAULT_FLOOR_PLAN_SETTINGS = {
  showFloorPlanButton: true,
  floorPlanButtonText: "View Floor Plan",
  bookingFormTemplateId: null,
  enableBookingRequest: false,
  bookingRequestFormTemplateId: null,
  enableBookingInterest: false,
  bookingInterestFormTemplateId: null,
  fillColor: "#ffffff",
  textColor: "#000000",
  buyerUnavailableFillColor: "#9e9b9b",
  buyerUnavailableTextColor: "#ffffff",
  opacity: 1,
  textOpacity: 1,
  availableColor: "#28a745",
  onHoldColor: "#ffc107",
  reservedColor: "#dc3545",
  blockedColor: "#6c757d",
};
